import { jsxs as m, jsx as c } from "react/jsx-runtime";
import { useTranslation as s } from "../../../../../hooks/useTranslation/index.js";
import { DealAction as p } from "../../../../../types/Deal/index.js";
import { DealActionBarCommentLinkButton as u, DealActionBarCommentIcon as d } from "./style.js";
import { Message as f } from "@pelando/fontawesome/icons";
const h = ({
  commentUrl: n,
  commentCount: r,
  id: a,
  title: e,
  inactive: t,
  disabledClick: o,
  dispatch: i
}) => {
  const { t: l } = s("deal");
  return /* @__PURE__ */ m(
    u,
    {
      url: n || "",
      disabledClick: o,
      onClick: () => {
        i({ type: p.CLICK_COMMENTS, payload: { id: a } });
      },
      "aria-disabled": t,
      title: e,
      style: {
        cursor: o ? "default" : "pointer",
        pointerEvents: o ? "none" : "all"
      },
      tabIndex: o ? -1 : 0,
      children: [
        /* @__PURE__ */ c(
          d,
          {
            icon: f,
            "aria-label": l("deal-action-bar-comment-button-title"),
            "aria-disabled": t
          }
        ),
        r
      ]
    }
  );
};
export {
  h as DealActionBarCommentLink
};
